import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper } from '@tanstack/react-table';
import Date from '../../../../../app/common/date';
import { EditAction } from './edit-action';
import { t } from '../../../../infra/i18n';
var columnHelper = createColumnHelper();
export var getColumns = function () { return [
    columnHelper.accessor('name', {
        minSize: 300,
        header: t('brand:list_page.table.name_header'),
    }),
    columnHelper.accessor('website', {
        minSize: 300,
        header: t('brand:list_page.table.website_header'),
    }),
    columnHelper.accessor('instagram', {
        minSize: 300,
        header: t('brand:list_page.table.instagram_header'),
    }),
    columnHelper.accessor('shopCount', {
        header: t('brand:list_page.table.shops_header'),
    }),
    columnHelper.accessor('createdAt', {
        cell: function (info) { return _jsx(Date, { children: info.getValue() }); },
        header: t('brand:list_page.table.date_added_header'),
    }),
    columnHelper.display({
        id: 'actions',
        header: t('brand:list_page.table.actions_header'),
        maxSize: 80,
        cell: function (props) { return _jsx(EditAction, { brand: props.row.original }); },
    }),
]; };
